import { AuthorisationFormValues } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { AuthorisationResponse, CreateOrUpdateAuthorisationRequest } from '../../../../api/models'
import { Authorisation } from './types'
import { AuthorisationUpdate } from './request'

export function toAuthorisationUpdate(
  transitOperationId: number,
  index: number,
  authorisation: AuthorisationFormValues,
): AuthorisationUpdate {
  return {
    transitOperationId,
    id: authorisation.id,
    type: authorisation.type,
    referenceNumber: authorisation.referenceNumber,
    sequenceNumber: authorisation.sequenceNumber ?? index,
  }
}

export function toAuthorisationUpdates(transitOperationId: number, authorisations: AuthorisationFormValues[]): AuthorisationUpdate[] {
  return authorisations.map((authorisation, index) => toAuthorisationUpdate(transitOperationId, index, authorisation))
}

export function toAuthorisationRequest(index: number, update: AuthorisationUpdate): CreateOrUpdateAuthorisationRequest {
  return {
    id: update.id,
    sequenceNumber: update.sequenceNumber,
    referenceNumber: update.referenceNumber,
    type: update.type,
    transitOperationId: update.transitOperationId,
  }
}

export function toAuthorisationRequests(updates: AuthorisationUpdate[]): CreateOrUpdateAuthorisationRequest[] {
  return updates.map((update, index) => toAuthorisationRequest(index, update))
}

export function fromAuthorisationResponse(index: number, response: AuthorisationResponse): Authorisation {
  return {
    id: response.id,
    sequenceNumber: response.sequenceNumber ?? index,
    referenceNumber: response.referenceNumber ?? '',
    type: response.type ?? '',
    deleted: false,
  }
}

export function fromAuthorisationResponses(responses: AuthorisationResponse[]): Authorisation[] {
  return responses.map((response, idx) => fromAuthorisationResponse(idx, response))
}
